<template>
	<div>
		<card>
			<Row :gutter="16">
			    <Col span="24">
					<div class="global-tool-bar">
						<div class="left-bar">
							<span class="title">客户品种数量统计分析</span>
							<DatePicker type="daterange"
							    v-model="selectDates"
							    size="small"
							    transfer
							    placement="bottom-end"
							    placeholder="选择期初和期末时间"
							    style=" margin-left:4px;width: 200px"
							    @on-change="onDateChange"></DatePicker>
								
								<Select v-model="userExternalCustomerLoginUuid"
								    style="width:200px;margin-left:5px;"
								    size="small"
								    placeholder="选择客户"
								    filterable
								    clearable>
								    <Option v-for="item in userList"
								        :key="item.userExternalCustomerLoginUuid"
								        :value="item.userExternalCustomerLoginUuid">{{ item.userName + '-' +item.userExternalCustomerName }}</Option>
								</Select>
								<RadioGroup v-model="subGroupBy"
								    style="margin-left:20px;"
								    type="button"
								    size="small">
								    <Radio label="mainCate"> <span>大类</span> </Radio>
								    <Radio label="subCate"> <span>小类</span> </Radio>
								    <Radio label="commodity"> <span>商品</span> </Radio>
								</RadioGroup>
											
								<Button type="success"
								    size="small"
								    class="btns"
								    icon="ios-stats"
								    @click="beginStat()">统计</Button>
						</div>
					</div>
				</Col>	
			</Row>
			
			<Row :gutter="16">
				<Col span="24">		
					<Table ref="mainTable"
					    :columns="mainTable.columns"
					    size="small"
					    :data="mainTable.data"
					    :loading="mainTable.loading"
					    :height="mainTable.tableHeight"
					    stripe
					    border />
					<Modal v-model="customerQantityProductModal.show"
						:width="1000"
						footer-hide>
						<Spin v-if="customerQantityProductModal.innerSpin"
							size="large"
							fix></Spin>
						<div slot="header">
							<span style="font-weight:bold;font-size: 14px;">客户品种数量统计</span>
						</div>
						<CustomerStatBar ref="customerStatBar"
							style="height: 400px;width:100%;"
							:value="customerQantityProductModal.barData"
							:text="customerQantityProductModal.barTitle" />
					</Modal>
				</Col>
			</Row>
		</card>
	</div>
	
</template>

<script>
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { getCustomerQuantityAnalyze } from '@/api/modules/stat-analyze/customer-analyze';
import CustomerStatBar from '@/components/charts/customer-stat-bar.vue';
import { getThisMonthStart, getTodayDateString } from '@/libs/logic';	
import { getAllUserList } from '@/api/modules/system-management/seedFarm-management';
export default{
    components:{
        StandPaginationTable,
        CustomerStatBar
    },
    data(){
        return{
            innerSpin:false,
            selectDates: [],
            userList:[],
            userExternalCustomerLoginUuid:'',
            saleType: ['pre'],
            subGroupBy: 'mainCate',
            mainTable: {
				    columns: [],
				    data: [],
				    loading: false,
				    tableHeight: 100
            },
            customerQantityProductModal:{
                show: false,
                innerSpin: false,
                barTitle: '',
                barData: {}
            }
        };
    },
    mounted() {
        let beginDate = this.getThisMonthStart();
        let endDate = this.getTodayDateString();
        this.selectDates = [beginDate, endDate];
        this.getUserList();
			
        this.mainTable.tableHeight
			    = window.innerHeight
			    - this.$refs.mainTable.$el.offsetTop
			    - 210;
    },
    methods:{
        getTodayDateString,
        getThisMonthStart,
        queryStat(postData) {
			    this.mainTable.loading = true;
			    getCustomerQuantityAnalyze(postData).then(res => {
			        this.mainTable.loading = false;
			        if (res.code === 0) {
			            this.makeNewField(res.data.columns);
			            this.mainTable.data = res.data.records;
			        }
			    });
        },
        getUserList() {
			    getAllUserList().then(res => {
			        if (res.code === 0) {
			            this.userList = res.data.userExternalCustomerList;
			        }
			    });
        },
        makeNewField(columns) {
			    this.mainTable.columns = [{ title: '周次', key: 'week', width: 60, align: 'center', fixed: 'left' }];
			    columns.forEach(c => {
			        const memberColumn = {
			            title: c,
			            key: c,
			            align: 'center',
                    renderHeader: (h, { column, index }) => {
						    return h('div',
						        [
						            h('span', {}, column.title),
						            h('icon', {
						                props: {
						                    type: 'md-stats',
						                    size: 18,
						                    color: 'red'
						                },
						                style: {
						                    marginLeft: '8px'
						                },
						                on: {
						                    click: () => {
						                        this.showChart(column);
						                    }
						                }
						
						            })
						        ]
						    );
                    }
			        };
			        this.mainTable.columns.push(memberColumn);
			    });
        },
        showChart(column) {
			
			    this.customerQantityProductModal.show = true;
			    this.customerQantityProductModal.innerSpin = true;
			    let barData = {};
			    for (let i = 0; i < this.mainTable.data.length - 1; i++) {
			        const e = this.mainTable.data[i];
			        barData[e['week']] = e[column.key];
			    }
			    this.customerQantityProductModal.barTitle = column.title;
			    this.customerQantityProductModal.barData = barData;
			    this.customerQantityProductModal.innerSpin = false;
			    this.$refs.customerStatBar.init();
        },
        onDateChange(e) {
			    this.selectDates = e;
        },
        onClickTab(e) {
			    this.$nextTick(() => {
			        this.beginStat();
			    });
        },
        beginStat(){
            let postData = {
				    beginDate: this.selectDates[0],
				    endDate: this.selectDates[1],
				    userUuid: this.userExternalCustomerLoginUuid,
				    selectType: this.subGroupBy
            };
            this.queryStat(postData);
        }
    }
		
};
</script>

<style>
</style>